import Vue from 'vue';
import VueRouter, { RouterOptions } from 'vue-router';
import { routers } from './router';
import ViewUI from 'view-design';
import Util from '../lib/util';
import { appRouters, otherRouters } from './router'

Vue.use(VueRouter);

const RouterConfig: RouterOptions = {
    mode: "history",
    routes: routers
};

export const router = new VueRouter(RouterConfig);

router.beforeEach((to, from, next) => {
    console.log('111111111', appRouters);
    ViewUI['LoadingBar'].start();
    Util.title(to.meta.title);
    let access_token = localStorage.getItem('access_token')
    if (to.meta.noLogin) {
        next();
    }else if (!access_token && !to.meta.noLogin) {
        next({
            name: 'login'
        });
    } else {
        const curRouterObj = Util.getRouterObjByName([otherRouters, ...appRouters], to.name);
        if (curRouterObj && curRouterObj.permission) {
            if (window.abp.auth.hasPermission(curRouterObj.permission)) {
                Util.toDefaultPage([otherRouters, ...appRouters], to.name, router, next);
            } else {
                next({
                    replace: true,
                    name: '401'
                });
            }
        } else {
            Util.toDefaultPage([...routers], to.name, router, next);
        }
    }
});
router.afterEach((to) => {
    Util.openNewPage(router.app, to.name, to.params, to.query);
    ViewUI['LoadingBar'].finish();
    window.scrollTo(0, 0);
});